<script setup lang="ts">
import type { FooterFields } from "@citizenm/lobby/shared/types/contentful";

const props = defineProps<{
  enabledSocials: FooterFields["showSocialLinks"];
}>();

const socialsMap = {
  Instagram: {
    url: "https://www.instagram.com/citizenm/",
    alt: "Follow us on Instagram",
    iconLocation:
      "https://images.ctfassets.net/50eu6hwcly4u/4gMCCfHD6OsZJ2pc5Ljjc/91473f1da37d45bc5c7a3a2bfeb3010d/instagram.svg?w=18&h=18&fm=webp&fit=fill",
  },
  Facebook: {
    url: "https://www.facebook.com/citizenMNL/",
    alt: "Visit our Facebook page",
    iconLocation:
      "https://images.ctfassets.net/50eu6hwcly4u/Lclx5ESeHSQs3s5w6THYZ/cf9c82a12072b4099709f44e9c295719/facebook.svg?w=18&h=18&fm=webp&fit=fill",
  },
  Linkedin: {
    url: "https://www.linkedin.com/company/citizenm",
    alt: "Connect with us on LinkedIn",
    iconLocation:
      "https://images.ctfassets.net/50eu6hwcly4u/49Qs1TAPC5gQUmYqtgn9C8/a569918b583bd09a8b67e854f8d31215/linkedin.svg?w=18&h=18&fm=webp&fit=fill",
  },
  TikTok: {
    url: "https://www.tiktok.com/@citizenmhotels",
    alt: "Check out our TikTok",
    iconLocation:
      "https://images.ctfassets.net/50eu6hwcly4u/3lMCPdDunFhkEhoEypPFcA/535fa1fb97850c34388efe074bb8abf8/tiktok.svg?w=18&h=18&fm=webp&fit=fill",
  },
  X: {
    url: "https://x.com/citizenm",
    alt: "Follow us on X",
    iconLocation:
      "https://images.ctfassets.net/50eu6hwcly4u/2aWTZY4lhh3aRmQKYylvSZ/787611c966abc4e920ac3c739545860c/x_icon.svg?w=18&h=18&fm=webp&fit=fill",
  },
};

const socialLinks = computed(() => {
  if (!props.enabledSocials) return [];

  return props.enabledSocials.map((social) => {
    return socialsMap[social as keyof typeof socialsMap];
  });
});
</script>

<template>
  <div class="social-links">
    <NuxtLink
      v-for="(item, index) in socialLinks"
      :key="index"
      class="social-links__link"
      target="_blank"
      :href="item.url"
    >
      <NuxtImg
        :src="item.iconLocation"
        :alt="item.alt"
        fit="contain"
        width="18"
        height="18"
        class="lazyautosizes lazyloaded"
        loading="lazy"
        format="webp"
      />
    </NuxtLink>
  </div>
</template>

<style scoped lang="scss">
.social-links {
  margin-top: 2.5rem;
  display: flex;
  justify-content: center;

  &__link:not(:last-of-type) {
    margin-right: 1.5rem;
  }
}
</style>
